export default {
    PERSONALISE: 'PERSONALISE',
    INSIGHT: 'INSIGHT',
};
